import { create } from "zustand";

interface MobileSidebarState {
  isOpenBurger: boolean;
  toggleBurgerSidebar: () => void;
  openBurgerSidebar: () => void;
  closeBurgerSidebar: () => void;
}

export const useMobileSidebarStore = create<MobileSidebarState>((set) => ({
  isOpenBurger: false,
  toggleBurgerSidebar: () =>
    set((state) => ({ isOpenBurger: !state.isOpenBurger })),
  openBurgerSidebar: () => set({ isOpenBurger: true }),
  closeBurgerSidebar: () => set({ isOpenBurger: false })
}));
